/* eslint-disable */
import * as Types from '../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetAocListVariablesDTO = Types.Exact<{
  search?: Types.Maybe<Types.Scalars['String']>;
  paging?: Types.Maybe<Types.PagingDTO>;
}>;


export type GetAocListDTO = (
  { __typename?: 'Query' }
  & { aocs: Array<(
    { __typename?: 'Aoc' }
    & Pick<Types.AocDTO, 'id' | 'name'>
  )> }
);


export const GetAocListDocumentDTO = gql`
    query getAocList($search: String, $paging: Paging) {
  aocs(
    filter: {archived: {equals: false}, name: {contains: $search}}
    paging: $paging
    sort: [{field: "name", order: ASC}]
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetAocList__
 *
 * To run a query within a React component, call `useGetAocList` and pass it any options that fit your needs.
 * When your component renders, `useGetAocList` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAocList({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetAocList(baseOptions?: Apollo.QueryHookOptions<GetAocListDTO, GetAocListVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAocListDTO, GetAocListVariablesDTO>(GetAocListDocumentDTO, options);
      }
export function useGetAocListLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetAocListDTO, GetAocListVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAocListDTO, GetAocListVariablesDTO>(GetAocListDocumentDTO, options);
        }
export type GetAocListHookResult = ReturnType<typeof useGetAocList>;
export type GetAocListLazyQueryDTOHookResult = ReturnType<typeof useGetAocListLazyQueryDTO>;
export type GetAocListQueryResultDTO = Apollo.QueryResult<GetAocListDTO, GetAocListVariablesDTO>;